import { render, staticRenderFns } from "./WAlert.vue?vue&type=template&id=06e1a236&scoped=true&"
import script from "./WAlert.vue?vue&type=script&lang=js&"
export * from "./WAlert.vue?vue&type=script&lang=js&"
import style0 from "./WAlert.vue?vue&type=style&index=0&id=06e1a236&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e1a236",
  null
  
)

export default component.exports